module.exports = __webpack_public_path__ + "img/flecha-new.08b661e4.svg";